import React from "react";
import Icon from "../../../components/AppIcon";

const CompliancePanel = ({ complianceData }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case "Compliant":
        return { name: "ShieldCheck", color: "var(--color-success)" };
      case "Review Required":
        return { name: "ShieldAlert", color: "var(--color-warning)" };
      case "Non-Compliant":
        return { name: "ShieldX", color: "var(--color-error)" };
      default:
        return { name: "Shield", color: "var(--color-muted-foreground)" };
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Compliant":
        return "bg-success/10 text-success";
      case "Review Required":
        return "bg-warning/10 text-warning";
      case "Non-Compliant":
        return "bg-error/10 text-error";
      default:
        return "bg-muted text-muted-foreground";
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon
          name="FileCheck"
          size={20}
          color="var(--color-primary)"
          className="md:w-6 md:h-6"
        />
        <h3 className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-foreground">
          Compliance Status
        </h3>
      </div>
      <div className="space-y-3 md:space-y-4">
        {complianceData?.map((item) => {
          const statusIcon = getStatusIcon(item?.status);
          return (
            <div
              key={item?.id}
              className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-base"
            >
              <div
                className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ background: `${statusIcon?.color}15` }}
              >
                <Icon
                  name={statusIcon?.name}
                  size={20}
                  color={statusIcon?.color}
                  className="md:w-6 md:h-6"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h4 className="text-sm md:text-base font-caption font-semibold text-foreground">
                    {item?.title}
                  </h4>
                  <span
                    className={`inline-flex px-2 py-1 rounded-full text-xs font-caption font-semibold whitespace-nowrap ${getStatusBadgeClass(item?.status)}`}
                  >
                    {item?.status}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-muted-foreground mb-2">
                  {item?.description}
                </p>
                {item?.lastChecked && (
                  <div className="flex items-center gap-1 text-xs text-muted-foreground">
                    <Icon name="Clock" size={12} />
                    <span>Last checked: {item?.lastChecked}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-4 md:mt-6 p-3 md:p-4 rounded-lg bg-primary/5 border border-primary/20">
        <div className="flex items-start gap-2 md:gap-3">
          <Icon
            name="Info"
            size={16}
            color="var(--color-primary)"
            className="flex-shrink-0 mt-0.5 md:w-5 md:h-5"
          />
          <div>
            <p className="text-xs md:text-sm font-caption text-foreground mb-1">
              <strong>UK Employment Law Compliance</strong>
            </p>
            <p className="text-xs md:text-sm text-muted-foreground">
              All TRONC distributions follow HMRC guidance and UK employment
              regulations.
              <a href="#" className="text-primary hover:underline ml-1">
                View full compliance report
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompliancePanel;
